<div class="flex flex-col h-full bg-white overflow-hidden">
  <main class="flex-1 p-5 overflow-hidden">
    <div class="bg-gris-4 rounded-[10px] h-full flex items-center justify-center">
      <div
        class="flex flex-col items-center gap-6 bg-white rounded-[14px] p-10 w-full max-w-[520px]"
      >
        <div class="mx-auto w-full flex flex-col gap-6">
          <!-- Form header -->
          <div class="text-center mb-2">
            <h1 class="text-[19px] fg-noir-1 text-600 font-semibold tracking-tight mb-3">
              {{ 'login.title' | translate }}
            </h1>
            <p class="text-[14px] fg-gris-1 text-400 font-normal">
              {{ 'login.subtitle' | translate }}
            </p>
          </div>

          <app-auth-credentials-form #authForm (success)="onLoginSuccess()" />

          <!-- Submit -->
          <button
            type="button"
            (click)="authForm.submit()"
            [disabled]="authForm.working()"
            class="w-full flex justify-center items-center h-[58px] gap-3 py-3 px-4 rounded-lg shadow-sm text-sm font-medium text-white bg-vert-1 hover:brightness-95 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 cursor-pointer"
            [class.bg-emerald-700]="authForm.working()"
            aria-label="{{ 'login.submit_button' | translate }}"
          >
            @if (authForm.rotating()) {
            <app-loader size="w-5 h-5" />
            } @else {
            <span class="material-icons transition-transform duration-500" [innerHTML]="authForm.statusIcon()"></span>
            }
            <span [innerHTML]="authForm.statusLabel() | translate"></span>
          </button>

          <!-- Links -->
          <div class="text-center">
            <a
              class="text-[14px] fg-gris-1 text-400 font-semibold no-underline hover:brightness-95 hover:underline transition-colors duration-150"
              routerLink="/reset-password/request"
              >{{ 'login.reset_password' | translate }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
